import {
  createContext,
  type FC,
  type PropsWithChildren,
} from 'react';
import {
  createPortal
} from 'react-dom';
import {
  useDispatch
} from 'react-redux';
import {
  useNavigate
} from 'react-router-dom';
import {
  setChosenCoinPackage,
  type CoinPackage,
} from '@entities/coins';
import {
  useSessionSelector,
  selectHasPlayerRegistrationStatus,
  selectHasFirstTimeDepositTag,
} from '@entities/session';
import {
  useGetWelcomePackages,
  useWelcomeOfferModalVisibility
} from '../lib';
import {
  WelcomeOfferModal
} from './welcome-offer-modal.component';

export const WelcomeOfferModalContext = createContext<null>(null);

export const WithWelcomeOfferModalProvider: FC<PropsWithChildren<unknown>> = ({ children }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const modalRoot = document.getElementById('modal-root');
  const { modalOpen, handleCloseWelcomeOfferModal } = useWelcomeOfferModalVisibility();
  const { coinPackages, isFetching } = useGetWelcomePackages();
  const hasPlayerRegistrationStatus = useSessionSelector(selectHasPlayerRegistrationStatus);
  const hasFirstTimeDepositTag = useSessionSelector(selectHasFirstTimeDepositTag);
  const handlePurchaseSelection = (coinPackage: CoinPackage): void => {
    dispatch(setChosenCoinPackage(coinPackage));
    handleCloseWelcomeOfferModal();
    navigate(hasPlayerRegistrationStatus ? '/checkout' : '/sign-up/complete-profile', { replace: true });
  };

  return (
    <WelcomeOfferModalContext.Provider value={null}>
      {children}
      {modalOpen && modalRoot && !hasFirstTimeDepositTag && createPortal((
        <WelcomeOfferModal
          coinPackages={coinPackages}
          loading={isFetching}
          onPurchaseSelection={handlePurchaseSelection}
          onClose={handleCloseWelcomeOfferModal}
        />), modalRoot)}
    </WelcomeOfferModalContext.Provider>
  );
};
